import { z } from 'zod';
/**
 * Notification contracts.
 * Collections: user_notifications, pushSubscriptions, notificationQueue —
 * shared between web (writer/reader) and api-node push module.
 */
export const UserNotificationMetaSchema = z
    .object({
    brand: z.string().nullish(),
    model: z.string().nullish(),
    /** Legacy docs store year as string; newer as number. */
    year: z.union([z.string(), z.number()]).nullish(),
    mileage: z.string().nullish(),
})
    .passthrough();
export const UserNotificationSchema = z
    .object({
    _id: z.unknown().nullish(),
    user_id: z.string(),
    car_id: z.string(),
    filter_id: z.string().nullish(),
    created_at: z.coerce.date().nullish(),
    meta: UserNotificationMetaSchema.nullish(),
    read: z.boolean().nullish(),
})
    .passthrough();
/** Browser Push API subscription as delivered by the client. */
export const WebPushSubscriptionSchema = z
    .object({
    endpoint: z.string(),
    expirationTime: z.number().nullish(),
    keys: z.object({ p256dh: z.string(), auth: z.string() }).passthrough(),
})
    .passthrough();
export const PushSubscriptionSchema = z
    .object({
    _id: z.unknown().nullish(),
    userId: z.string(),
    /** Duplicated top-level for lookups; canonical value lives in subscription.endpoint. */
    endpoint: z.string().nullish(),
    subscription: WebPushSubscriptionSchema.nullish(),
    createdAt: z.coerce.date().nullish(),
})
    .passthrough();
export const NotificationQueueItemSchema = z
    .object({
    _id: z.unknown().nullish(),
    userId: z.string().nullish(),
    status: z.string().nullish(),
    attempts: z.number().int().nullish(),
    payload: z.record(z.unknown()).nullish(),
    createdAt: z.coerce.date().nullish(),
    processedAt: z.coerce.date().nullish(),
})
    .passthrough();
//# sourceMappingURL=notification.js.map